import { render, staticRenderFns } from "./TeacherTagDialog.vue?vue&type=template&id=08208cab&scoped=true"
import script from "./TeacherTagDialog.vue?vue&type=script&lang=js"
export * from "./TeacherTagDialog.vue?vue&type=script&lang=js"
import style0 from "./TeacherTagDialog.vue?vue&type=style&index=0&id=08208cab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08208cab",
  null
  
)

export default component.exports